<template>
    <div class="form full-form auth-cover">
        <router-view></router-view>
    </div>
</template>

<script>
import '@/assets/sass/authentication/auth.scss';
export default {
    metaInfo: { title: 'Register Cover' },
};
</script>
